import { Avatar } from '../dashboards/primitives';

const CAPTION = {
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: '.06em',
  textTransform: 'uppercase',
  color: 'var(--nb-subtle)',
  marginBottom: 6,
} as const;

const EMAIL = {
  fontSize: 11.5,
  color: 'var(--nb-subtle)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export interface GiftPassPartyBlockProps {
  caption: string;
  name: string | null;
  email: string | null;
  emptyText: string;
}

export function GiftPassPartyBlock({ caption, name, email, emptyText }: GiftPassPartyBlockProps) {
  const headline = name ?? email;
  return (
    <div style={{ minWidth: 0 }}>
      <div style={CAPTION}>{caption}</div>
      {headline ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Avatar name={headline} color="var(--nb-primary)" size={30} />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 13.5, fontWeight: 700, overflowWrap: 'anywhere' }}>
              {headline}
            </div>
            {name && email && <div style={EMAIL}>{email}</div>}
          </div>
        </div>
      ) : (
        <div style={{ fontSize: 12.5, color: 'var(--nb-faint)', fontStyle: 'italic' }}>
          {emptyText}
        </div>
      )}
    </div>
  );
}
